import { gql } from '@apollo/client';

export const UPDATE_AGENT_CONFIGURATION = gql`
  mutation UpdateAgentConfiguration($params: UpdateAgentConfigurationInput!) {
    updateAgentConfiguration(params: $params) {
      success
      message
      errors
      data {
        id
        agentKey
        provider
        modelName
        temperature
        maxTokens
        maxOutputTokens
        maxRetries
        topP
        description
        isEnabled
        createdAt
        createdBy
      }
    }
  }
`;
